import Navigation from "../../components/Navigation/Navigation.js";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation.js"
import Table from "../../components/Table/Table.js";
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import { context, } from '../../context/authContext.js';
import useApi from '../../helpers/api.js';
import Loader from "../../components/Loader/Loader.js";
import useColumns from './columns.js';
import useActions from './acciones.js';
import ConfirmModal from "../../components/Modal/Modal.js"


export default function Empresas() {
  const [data, setData] = useState(null);
  const { handleLogout, user } = useContext(context);
  const gridRef = useRef();
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const  columnDefs  = useColumns(setSelectedRow,setModalOpen);
  const { createHook, onCellEditingStopped, confirmDelete } = useActions();
  const api = useApi();

  const canCreate = useMemo(() => ({
    canCreate: Array.isArray(user?.rol) 
      ? user.rol.some(m => m.nombre === "Empresas" && m.permiso.includes("crear")) 
      : false,
    button: "Crear empresa"
  }), [user?.rol]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getEmpresas();
        if (response?.response?.data?.error) {
          handleLogout();
          return;
        }
        setData(response)
      } catch (err) {
        handleLogout();
      }
    };

    fetchData();  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout]);

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Empresas" />
      {!!data ? 
        <Table 
        columns={columnDefs} 
        data={data}
        onCellEditingStopped={onCellEditingStopped}
        canCreate={canCreate}
        createHook={createHook}
        gridRef={gridRef}
        />
      :
        <Loader/>
      }
      <ConfirmModal
        isOpen={modalOpen}
        tipo= "confirmacion"
        message={`Are you sure you want to delete ${selectedRow?.data.nombre}?`}
        onConfirm={()=>confirmDelete(gridRef, selectedRow, setModalOpen, setSelectedRow)}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
}